"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _styles = require("./styles");

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var INLINE_MARGIN = _designLanguage.Inline.Sizes.XxSmall;

var InputWrapper = function InputWrapper(_ref) {
  var isBare = _ref.isBare,
      isDisabled = _ref.isDisabled,
      isAdjustableHeight = _ref.isAdjustableHeight,
      isRounded = _ref.isRounded,
      error = _ref.error,
      renderBeforeContent = _ref.renderBeforeContent,
      renderAfterContent = _ref.renderAfterContent,
      renderConnectedBefore = _ref.renderConnectedBefore,
      renderConnectedAfter = _ref.renderConnectedAfter,
      children = _ref.children,
      size = _ref.size,
      hasDefaultRenderContent = _ref.hasDefaultRenderContent;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  var inputTextStyles = (0, _utils.getThemeFieldTextStyles)({
    theme: theme,
    size: size,
    styleType: 'Input'
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.InputRoot, {
    themeHeight: theme.Size[_constants.SizeSemantics[size]]
  }, renderConnectedBefore && /*#__PURE__*/_react["default"].createElement(_styles.InputConnectedWrapper, {
    side: "left",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedBefore()), /*#__PURE__*/_react["default"].createElement(_styles.InputContainer, {
    size: size,
    error: error,
    disabled: isDisabled,
    isBare: isBare,
    roundedLeft: !!!renderConnectedBefore,
    roundedRight: !!!renderConnectedAfter,
    isRounded: isRounded || theme.Shape.Field === _designLanguage.Shape.Pill,
    isAdjustableHeight: isAdjustableHeight,
    renderVerticalPadding: isAdjustableHeight || !!renderBeforeContent || !!renderAfterContent,
    leadingRenderContent: !!renderBeforeContent,
    trailingRenderContent: !!renderAfterContent,
    mobileInputTextStyles: inputTextStyles.mobile,
    desktopInputTextStyles: inputTextStyles.desktop,
    hasDefaultRenderContent: hasDefaultRenderContent
  }, renderBeforeContent && /*#__PURE__*/_react["default"].createElement(_designLanguage.Inline, {
    size: INLINE_MARGIN
  }, renderBeforeContent()), /*#__PURE__*/_react["default"].createElement(_styles.InputContentContainer, {
    isAdjustableHeight: isAdjustableHeight,
    hasTrailingRenderContent: !!renderAfterContent
  }, children), renderAfterContent && /*#__PURE__*/_react["default"].createElement(_designLanguage.Inline, {
    size: _designLanguage.Inline.Sizes.None
  }, renderAfterContent())), renderConnectedAfter && /*#__PURE__*/_react["default"].createElement(_styles.InputConnectedWrapper, {
    side: "right",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedAfter()));
};

InputWrapper.Sizes = _constants.Sizes;
InputWrapper.propTypes = {
  isBare: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isAdjustableHeight: _propTypes["default"].bool,
  isRounded: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  renderBeforeContent: _propTypes["default"].func,
  renderAfterContent: _propTypes["default"].func,
  renderConnectedBefore: _propTypes["default"].func,
  renderConnectedAfter: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired,
  size: _propTypes["default"].oneOf(Object.values(_constants.Sizes)),
  hasDefaultRenderContent: _propTypes["default"].bool
};
var _default = InputWrapper;
exports["default"] = _default;